<template>
<!-- 选择商品弹窗 -->
<el-dialog title="选择商品"
:visible.sync="selectDialog"
width="1200px"
:before-close="handleDialogClose"
append-to-body>
    <div class="goodsDialog">
        <div style="margin-bottom:10px;">
            <el-button @click="switchTab(0)">快速选择</el-button>
            <el-button @click="switchTab(1)">导入商品ID</el-button>
            <span class="shopTittle">店铺:{{itemListparam.sellerNick}}</span>
        </div>
        <div class="formCnt" v-if="itemListparam.searchType===0">
            <div><el-select v-model="itemListparam.categoryType"  
                style="width:120px;"
                @change="classifyChange">
                <el-option value="0" label="店铺类目"></el-option>
                <el-option value="1" label="淘宝类目"></el-option>   
            </el-select>
            <el-popover placement="bottom" width="300" v-model="visible" class="poper">
             <div class="popper-wrapper">
                <el-tree
                ref="sellerTree"
                node-key="id"
                v-if="itemListparam.categoryType === '0'"
                :data="sellerCats"
                :props="props"
                show-checkbox
                @check-change="handleCheckChange"
                ></el-tree>
                <el-tree
                ref="taobaoTree"
                node-key="id"
                v-else-if="itemListparam.categoryType === '1'"
                :data="taobaoCats"
                :props="props"
                show-checkbox
                @check-change="handleCheckChange"
                ></el-tree>
             </div>
             <div style="text-align: right; margin-top: 20px;">
                <el-checkbox
                v-model="checkedAll"
                @change="handleCheckAllChangeTaoBao"
                style="float:left;line-height:26px;"
                >全选</el-checkbox>
                <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="getCheckedKeys()">确定</el-button>
             </div>
             <el-button slot="reference" size="small" style="width:123px;vertical-align:top;">
                {{classifyIdArray.length >
                0 ? '已选择' + classifyIdArray.length + '项' : '默认全部'}}
             </el-button>
            </el-popover>
            </div>
            <div><el-input
                class="short-input"
                style="width:150px;margin-left:15px;"
                placeholder="请输入商品标题"
                size="small"
                v-model="itemListparam.itemTitle"
              ></el-input></div>
            <div><el-input
                class="short-input"
                style="width:150px;margin-left:15px;"
                placeholder="请输入商品ID"
                size="small"
                v-model="itemListparam.numIid"
              ></el-input></div>
            <div style="float: right;">
                <el-button type="primary" size="small" style="width:90px;" @click="searchList">查询</el-button>
            </div>
        </div>
        <div class="tableCnt" v-if="itemListparam.searchType===0">
            <div>
                <el-table
                :data="leftData"
                ref="leftTable"
                :header-cell-style="{background:'#FAFAFA'}"
                :row-class-name="tableRowClassName"
                style="width: 566px; border: 1px solid #E1E1E6;">
                    <el-table-column label="店中宝贝" align="center" width="460">
                        <template slot-scope="scope">
                            <div class="shops-goods">
                                <div class="goods-left">
                                    <img :src="scope.row.picUrl" class="goods-img" alt>
                                </div>
                                <div class="goods-right">
                                    <p class="goods-name">
                                    <span class="goods-title">{{scope.row.itemTitle}}</span>
                                    </p>
                                    <div class="goods-detail">
                                    <span
                                        class="goods-id"
                                        style="color:#888;font-size:14px;"
                                    >商品ID:{{scope.row.numIid}}</span>
                                    <span class="goods-price" style="float:right;font-size:18px;">
                                        <span class="price">￥{{scope.row.price}}</span>
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center">
                        <template slot="header" slot-scope="scope">
                            <el-button
                                    size="small"
                                    type="text"
                                    @click="handleAllSelect()">全选</el-button>
                        </template>
                        <template slot-scope="scope">
                            <span v-if="scope.row.state=== true" class="el-icon-circle-plus-outline add-button" style="color:#2062e7;"></span>
                            <span v-else class="el-icon-circle-plus-outline add-button" style="color:#2062e7;" @click="handleSelect(scope.row,scope.$index)"></span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    @size-change="handleLeftSizeChange"
                    @current-change="handleLeftCurrentChange" 
                    :current-page="itemListparam.pageNum" 
                    :page-size="itemListparam.pageSize" 
                    :page-sizes="[5,10,50,100,1000]"
                    layout="total,sizes,prev,pager,next,jumper"
                    :total="leftTotal"
                    style="text-align: right; margin-top: 20px;">
                </el-pagination>
            </div>
            <div>
                <el-table
                :data="rightDataShow"
                ref="rightTable"
                :header-cell-style="{background:'#FAFAFA'}"
                style="width: 566px; border: 1px solid #E1E1E6;">
                    <el-table-column align="center" width="460">
                        <template slot="header" slot-scope="scope">
                            <span>已选择宝贝</span>
                            <span class="is-select">({{rightData.length}})</span>
                        </template>
                        <template slot-scope="scope">
                            <div class="shops-goods">
                                <div class="goods-left">
                                    <img :src="scope.row.picUrl" class="goods-img" alt>
                                </div>
                                <div class="goods-right">
                                    <p class="goods-name">
                                    <span class="goods-title">{{scope.row.itemTitle}}</span>
                                    </p>
                                    <div class="goods-detail">
                                    <span
                                        class="goods-id"
                                        style="color:#888;font-size:14px;"
                                    >商品ID:{{scope.row.numIid}}</span>
                                    <span class="goods-price" style="float:right;font-size:18px;">
                                        <span class="price">￥{{scope.row.price}}</span>
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center">
                        <template slot="header" slot-scope="scope">
                            <el-button size="small" type="text" @click="handleClear">清空</el-button>
                        </template>
                        <template slot-scope="scope">
                            <span class="el-icon-circle-close delete-button" style="color:#2062e7;" @click="handleDelete(scope.row, scope.$index)"></span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                background
                @size-change="handleRightSizeChange"
                @current-change="handleRightCurrentChange" 
                layout="total,sizes,prev,pager,next,jumper"
                :page-sizes="[5,10,50,100,1000]"
                :current-page="rightPaginationInfo.pageNum" 
                :page-size="rightPaginationInfo.pageSize"
                :total="rightPaginationInfo.totalCount"
                style="text-align: right; margin-top: 20px;">
                </el-pagination>
            </div>
        </div>
        <div class="importids" v-if="itemListparam.searchType===1">
            <div class="inputbox">
                <el-input
                type="textarea"
                :rows="10"
                placeholder="请输入宝贝ID"
                @change="checkRow"
                v-model="itemListparam.numIids">
                </el-input>
                <el-button style="margin:10px 0;display: block;" type='primary' size="small" @click="searchInput">查询</el-button>
                <div style="white-space: normal;">请以换行区隔宝贝ID，最多只能输入50个宝贝ID以供选择</div>
            </div>
            <div class="inputtable">
                <el-table
                ref="multipleTable"
                :data="inputData"
                @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#FAFAFA'}"
                style="width: 612px; border: 1px solid #E1E1E6;">
                    <el-table-column type="selection" width="50"></el-table-column>
                    <el-table-column align="center" width="560">
                        <template slot="header" slot-scope="scope">
                            <span>已选择宝贝</span>
                            <span class="is-select">({{SelectInput.length}})</span>
                        </template>
                        <template slot-scope="scope">
                            <div class="shops-goods">
                                <div class="goods-left">
                                    <img :src="scope.row.picUrl" class="goods-img" alt>
                                </div>
                                <div class="goods-right">
                                    <p class="goods-name">
                                    <span class="goods-title">{{scope.row.itemTitle}}</span>
                                    </p>
                                    <div class="goods-detail">
                                    <span
                                        class="goods-id"
                                        style="color:#888;font-size:14px;"
                                    >商品ID:{{scope.row.numIid}}</span>
                                    </div>
                                </div>
                                <div class="pricecnt" style="float:right;width:100px;height:100px;line-height:100px;">
                                    <span class="goods-price" style="font-size:18px;">
                                        <span class="price">￥{{scope.row.price}}</span>
                                    </span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    @size-change="handleInputSizeChange"
                    @current-change="handleInputCurrentChange" 
                    :current-page="InputPaginationInfo.pageNum" 
                    :page-size="InputPaginationInfo.pageSize" 
                    :page-sizes="[5,10,50,100,1000]"
                    layout="total,sizes,prev,pager,next,jumper"
                    :total="InputPaginationInfo.total"
                    style="text-align: right; margin-top: 20px;">
                </el-pagination>
            </div>
        </div>
        <div style='text-align:center;margin-top:10px;'>
            <el-button type="primary" style="width:150px;" @click="transData">保存</el-button>
        </div>
    </div>
</el-dialog>
</template>
<script>
// import {getSellercats,getTaobaocats,getTaobaoItemList,queryItemDetail} from '../api/public'
import {getSellercats} from '@/api/analysis/ware-controller';
export default{
    name:'select-goods',
    props:{
        goodsArr:{
            type:Array,
            default:()=>[]
        },
        shopItem:{
            type:Object,
            default:()=>null
        },
    },
    watch: {
        rightData(newVal,oldVal){
            this.rightPaginationInfo.totalCount = newVal.length;
            let start=(this.rightPaginationInfo.pageNum-1)*this.rightPaginationInfo.pageSize;
            let page=(start+this.rightPaginationInfo.pageSize)>this.rightPaginationInfo.totalCount?this.rightPaginationInfo.totalCount%this.rightPaginationInfo.pageSize:this.rightPaginationInfo.pageSize;
            console.log(start,page);
            this.rightDataShow=this.rightData.slice(start,start+page);  
        }
    },
    data(){
        return{
            selectDialog:true,
            checkedAll:false,
            classifyIdArray:[],
            classifyIdString:"",
            visible:false,
            sellerCats:[],
            taobaoCats:[],
            props: {
                label: "speName001",
                children: "child"
            },
            leftData:[],
            rightData:[],
            rightDataShow:[],
            inputData:[],
            SelectInput:[],
            itemListparam:{
                categoryType:"0",
                cid:"",
                searchType:0,
                sellerNick:"",
                itemTitle:"",
                numIid:"",
                pageSize:5,
                pageNum:1,
                numIids:"",
            },
            leftTotal:0,
            InputPaginationInfo:{
                pageNum: 1, //当前页数
                pageSize: 5, //当前页面数据大小
                total: 0 //数据总数
            },
            rightPaginationInfo:{
                pageNum: 1,
                pageSize: 5,
                totalCount: 0
            },
            reserveInput:[],
        }
    },
    mounted(){
        console.log(this.goodsArr,this.shopItem);
        let that=this;
        this.shopItem.appointGoodsType!=="" && (this.itemListparam.searchType=this.shopItem.appointGoodsType);
        this.itemListparam.sellerNick=this.shopItem.sellerNick;
        getSellercats().then(res=>{
            // if(res.code==200){console.log(res.data);  that.sellerCats = res.data;}
            console.log(res);
        });//获取店铺类目
        // getTaobaocats({sellerNick:this.shopItem.sellerNick}).then(res=>{
        //     if(res.code==200){that.taobaoCats = res.data;}
        // });//获取淘宝类目
        //回显
        if(this.goodsArr && this.goodsArr.length!=0){
            queryItemDetail({sellerNick:this.shopItem.sellerNick,numIidList:this.goodsArr.map(i=>String(i.goodsId)).join(",")}).then(res=>{
                if(res.code==200){
                    if(this.itemListparam.searchType===0){
                        this.rightData=res.data;
                    }else{
                        this.SelectInput=res.data;
                    }
                    this.getItemList();
                }
            });
        }
        this.getItemList();
    },
    methods:{
        checkRow(val){
            if(val.split("\n").filter((item)=>{return item!=="";}).length>50){
                this.$message.info("最多可以输入50个id，请仔细核对");
            };
        },
        switchTab(val){
           this.itemListparam.searchType=val;
           if(val===1){
               this.leftData=[];
               this.rightData=[];
           }else{
               this.inputData=[];
           }
        },
        handleDialogClose(){
            this.$emit("transferName",[],false);
            this.selectDialog=true;
        },
        getCheckedKeys(){
            const that = this;
            let classifyIndex = that.itemListparam.categoryType;
            let classifyIdArray = [];
            if (classifyIndex === '1') {
                classifyIdArray = that.$refs.taobaoTree.getCheckedKeys();
                that.classifyIdArray = classifyIdArray;
                that.classifyIdString = classifyIdArray.join(",");
            } else if (classifyIndex === '0') {
                // 获取所有选中的id
                classifyIdArray = that.$refs.sellerTree.getCheckedKeys();
                that.classifyIdArray = classifyIdArray;
                that.classifyIdString = classifyIdArray.join(",");
            }
            that.visible = false;
            console.log(this.classifyIdString);
        },
        traceBack(){//初始化商品状态
            let that=this;
            if(this.itemListparam.searchType=== 0){
                let rightId=this.rightData.map(i=>i.numIid);
                this.leftData.forEach(item=>{
                    if(rightId.indexOf(item.numIid)!==-1){
                        item.state=true;
                    }
                });
            }else{  
                this.$nextTick(()=>{ 
                    that.inputData.forEach((item,ind)=>{
                        if(that.reserveInput.map(i=>i.numIid).indexOf(item.numIid)!==-1){
                            that.$refs.multipleTable.toggleRowSelection(that.inputData[ind],true);
                        }
                    });
                    this.SelectInput=[...this.reserveInput];
                })
            }
        },
        getItemList(){//查询商品列表
            let obj={...this.itemListparam};
            obj.cid=this.classifyIdString;
            // obj.searchType=0;
            this.reserveInput=[...this.SelectInput];
            console.log(this.reserveInput,this.SelectInput);
            getTaobaoItemList(obj).then(res=>{
                if (res.code === 200) {
                    let dataList = [...res.data.dataList];
                    //给商品列表添加一个state属性判断是否可以被选中
                    if(this.itemListparam.searchType=== 0){//条件查询
                        for (let i = 0; i < dataList.length; i++) {
                            dataList[i].state = false;
                        }
                        this.leftData=dataList;
                        this.leftTotal= res && res.data.pageInfo.total;
                    }else{//输入ID查询
                        this.inputData=dataList;
                        this.InputPaginationInfo.total= res && res.data.pageInfo.total;
                    }
                    console.log(this.reserveInput,this.SelectInput);
                    this.traceBack();
                }
            });
        },
        handleCheckAllChangeTaoBao(val){
            if (val) {
                if (this.itemListparam.categoryType === '1') {
                this.$refs.taobaoTree.setCheckedNodes(this.taobaoCats);
                } else {
                this.$refs.sellerTree.setCheckedNodes(this.sellerCats);
                }
            } else {
                if (this.itemListparam.categoryType === '1') {
                this.$refs.taobaoTree.setCheckedNodes([]);
                } else {
                this.$refs.sellerTree.setCheckedNodes([]);
                }
            }
        },
        handleCheckChange(){
            if (this.itemListparam.categoryType === '1') {
                let arr = this.$refs.taobaoTree.getCheckedKeys();
                console.log(arr);
            } else {
                let arr = this.$refs.sellerTree.getCheckedKeys();
                console.log(arr);
            }
        },
        classifyChange(){
            this.checkedAll = false;
            this.classifyIdArray = [];
            this.classifyIdString = "";
        },
        searchList(){
            this.getItemList();
        },
        handleSelect(row, index){//左边选择
            if (row.state === false) {
                this.rightData.push(row);
                row.state = true;
            }
        },
        handleAllSelect(){
            for (let i = 0; i < this.leftData.length; i++) {
                if (this.leftData[i].state === false) {
                    this.rightData.push(this.leftData[i]);
                    this.leftData[i].state = true;
                }
            }
        },
        handleDelete(row, index){//右侧删除
            this.rightData.splice(this.rightData.indexOf(row.numIid),1);
            for (let i = 0; i < this.leftData.length; i++) {
                if (this.leftData[i].numIid == row.numIid) {
                    this.leftData[i].state = false;
                }
            }
        },
        handleClear(){//右侧清空
            for (let i = 0; i < this.rightData.length; i++) {
                for (let j = 0; j < this.leftData.length; j++) {
                    if (this.rightData[i].numIid == this.leftData[j].numIid) {
                        this.leftData[j].state = false;
                    }
                }
            }
            this.rightData.splice(0,this.rightData.length);
        },
        searchInput(){//根据输入的宝贝ID查询
            this.getItemList();
        },
        handleSelectionChange(val){//手动输入勾选
           this.SelectInput=val;
        },
        tableRowClassName({ row }) {
            if (row.state === true) {
            return "success-row";
            }
            return "";
        },
        transData(){
            let selData=[],transInfo=[];
           if(this.itemListparam.searchType===0){//快速选择
               selData=[...this.rightData];
           }else{
               selData=[...this.SelectInput];
           }
           selData.forEach(item=>{
               let obj={goodsId:"",goodsName:"",goodsPrice:""};
               obj.goodsId=item.numIid;
               obj.goodsName=item.itemTitle;
               obj.goodsPrice=item.price;
               transInfo.push(obj);
           });
           this.$emit("transferName",transInfo,{sellerNick:this.shopItem.sellerNick,searchType:this.itemListparam.searchType});
           this.selectDialog=true;
        },
        handleLeftSizeChange(val){
            this.itemListparam.pageNum=1;
            this.itemListparam.pageSize=val;
            this.getItemList();
        },
        handleLeftCurrentChange(val){
            this.itemListparam.pageNum=val;
            this.getItemList();
        },
        handleInputSizeChange(val){
            this.InputPaginationInfo.pageNum=1;
            this.InputPaginationInfo.pageSize=val;
            this.getItemList();
        },
        handleInputCurrentChange(val){
            this.InputPaginationInfo.pageNum=val;
            this.getItemList();
        },
        handleRightSizeChange(val){
            this.rightPaginationInfo.pageNum=1;
            this.rightPaginationInfo.pageSize=val;
            this.rightPaginationInfo.totalCount = this.rightData.length;
            let start=(this.rightPaginationInfo.pageNum-1)*this.rightPaginationInfo.pageSize;
            let page=(start+this.rightPaginationInfo.pageSize)>this.rightPaginationInfo.totalCount?this.rightPaginationInfo.totalCount%this.rightPaginationInfo.pageSize:this.rightPaginationInfo.pageSize;
            console.log(start,page);
            this.rightDataShow=this.rightData.slice(start,start+page); 
        },
        handleRightCurrentChange(val){
            this.rightPaginationInfo.pageNum=val;
            this.rightPaginationInfo.totalCount = this.rightData.length;
            let start=(this.rightPaginationInfo.pageNum-1)*this.rightPaginationInfo.pageSize;
            let page=(start+this.rightPaginationInfo.pageSize)>this.rightPaginationInfo.totalCount?this.rightPaginationInfo.totalCount%this.rightPaginationInfo.pageSize:this.rightPaginationInfo.pageSize;
            console.log(val,start,page);
            this.rightDataShow=this.rightData.slice(start,start+page); 
        }
    },
}
</script>
<style lang='scss' scoped>
/deep/.el-table .success-row{
  background: #f5f7fa;
  cursor: not-allowed;
  opacity: 0.4;
}
.goodsDialog{
    padding-bottom:20px;
    .shopTittle{
        float:right;
        height:32px;
        line-height:32px;
        color:#353192;  
    }
    .formCnt{
        margin-bottom: 15px;
        &>div{
            display: inline-table;
            height:32px;
            line-height:32px;
            vertical-align:top;
        }
    }
    .tableCnt>div{
        display: inline-block;
        width:50%;
        vertical-align: top;
        .add-button{
            font-size: 24px;
            cursor: pointer;
        }
        .delete-button {
            font-size: 24px;
            cursor: pointer;
        }
        .shops-goods {
            position: relative;
            .goods-left {
                float: left;
                width: 100px;
                .goods-img {
                width: 80px;
                float: left;
                margin: 20px 10px 10px 10px;
                }
            }
            .goods-right {
                font-size: 16px;
                height: 100px;
                float: right;
                text-align: left;
                width: 300px;
            }
        }
    }
    .importids{
        .inputbox{
            width:200px;
            display: inline-block;
        }
        .inputtable{
            display: inline-block;
            vertical-align: top;
            margin-left:20px;
            .shops-goods {
                position: relative;
                &>div{
                    display: inline-block;
                    vertical-align:top;
                }
                .goods-left {
                    width: 100px;
                    .goods-img {
                        width: 80px;
                        float: left;
                        margin: 20px 10px 10px 10px;
                    }
                }
                .goods-right {
                    font-size: 16px;
                    height: 100px;
                    text-align: left;
                    width: 300px;
                    margin-left:10px;
                }
                .pricecnt{
                }
            }
        }
    } 
}
</style>